import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class filterAutoComplete_template extends vnTemplate{

    protected delay = 400;
    protected debounceTimerId: number;

    protected getTemplateHtml(): string{

        return `
                <div class="w-spec-search icon i-auto-complete" data-bind="visible: isVisible, css: icon">
                    <input data-bind="event: { keyup: onChangeInput, blur: onBlurInput }, valueUpdate : 'afterkeydown', attr:{id:idSelectedItem, placeholder:placeHolderText}, textInput: nameSelectedItem" list="items" class="input-text">
                        <ul class="form-auto-list" data-bind="foreach: items,  visible: isShowItemSuggestions" id="items">
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: name, css: $data.iconImage || '', click: $parent.onClickInput" ></li>
                        </ul>
                    </input>
                    <button data-bind="attr: {id: 'user-input-close_' + elementIdentifier()}, event: { click: onClearInput}" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string{
        return "filterAutoComplete-template";
    }

    protected getMainElementClasses(): Array<string>{
    	return [];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {    items: ko.observableArray([])
                    ,idSelectedItem: ko.observable(null)
                    ,nameSelectedItem: ko.observable("")
                    ,placeHolderText: ko.observable("")
                    ,elementIdentifier: ko.observable(this.idElement)
                    ,orderBy: "dateCreation"
                    ,orderByDirection: "DESC"
                    , isShowItemSuggestions: ko.observable(false)
                    , isVisible: ko.observable(false)
                    , icon: ko.observable("i-user2")
                    , onChangeInput: function (data, event) { huit_neuf_this.onChangeInput(event); }
                    , onClearInput: function (data, event) { huit_neuf_this.onClearInput(event); }
                    , onClickInput: function (data, event) { huit_neuf_this.onClickInput(data, event); }
                    , onBlurInput: function (data, event) { huit_neuf_this.onBlurInput(data, event); }
                };
    }

    protected onChangeInput(event){

        this.getTemplateViewModel().items([]);

        clearTimeout(this.debounceTimerId);

        let _myThis = this;
        this.debounceTimerId = window.setTimeout(function(){

            _myThis.updateSelectedItem(event, _myThis.getTemplateViewModel().idSelectedItem);
        }, this.delay);
    }

    protected updateSelectedItem(event, idSelectedItem){
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options:any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3) {
            this.caller.getAutoCompleteSuggestions(this.idElement, inputVal);
            this.getTemplateViewModel().isShowItemSuggestions(true);
        }else {
            this.getTemplateViewModel().isShowItemSuggestions(false);
        }
/*
        if (inputVal.length > 0 ) {

            for (let op of options) {
                if (op.value === inputVal) {
                    idSelectedItem(op.id);
                    input.blur();
                    this.caller.filterSimpleOnChange();
                    break;
                }
            }
        }
*/
        if (this.getTemplateViewModel().idSelectedItem() != null) {

            let closeBtn = document.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());
            closeBtn.classList.remove('is-showing');
            this.viewModel[this.idElement].idSelectedItem(null);
            this.caller.filterSimpleOnChange();
        }

    }

    protected onClearInput(event){
        let button = event.target;

        button.classList.remove('is-showing');
        this.viewModel[this.idElement].idSelectedItem(null);
        this.viewModel[this.idElement].nameSelectedItem("");
        this.caller.filterSimpleOnChange();

    }

    protected onClickInput(data, event) {
        this.getTemplateViewModel().nameSelectedItem(data.name)
        this.getTemplateViewModel().idSelectedItem(data.id);
        this.getTemplateViewModel().isShowItemSuggestions(false);
        this.getTemplateViewModel().items([]);


        let closeBtn = document.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());

        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }

        this.caller.filterSimpleOnChange();
    }

    protected onBlurInput(data, event) {

        setTimeout(function (tmpl) {
            console.log(tmpl.idSelectedItem());
            if (tmpl.idSelectedItem() == null) {
                tmpl.nameSelectedItem("");
            }
            tmpl.isShowItemSuggestions(false);
            tmpl.items([]);
        }, 250, this.viewModel[this.idElement]);
    }

    public setIsVisible(isVisible){
        this.getTemplateViewModel().isVisible(isVisible);
    }

    public setItems(items){
        this.getTemplateViewModel().items(items);
    }

    public setPlaceHolderText(placeHolderText){
        this.getTemplateViewModel().placeHolderText(placeHolderText);
    }

    public setIcon(icon){
        this.getTemplateViewModel().icon(icon);
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template.ts